import { ErrorResponse} from '@gtpl/shared-models/common-models';
import { AllHsnResponseModel, HsnCodeRequestByVal, HsnDto, HsnResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
// import { GetValueAdditionDataByhsnCodesRequest } from './dto/get-valu-addition-data-by-hsn-codes.request';
import { HsnCodesAdapter } from './dto/hsn-codes.adapter';
import { HsnCodesDTO } from './dto/hsn-codes.dto';
import { HsnCodesRequest } from './dto/hsn-codes.request';
import { HsnRequest } from './dto/hsn.request';
// import { hsnDataRequest } from './dto/hsn-data-request';
import { HsnCodes } from './hsn-codes.entity';


@Injectable()
export class HsnCodesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(HsnCodes)
        private hsnCodesRepository: Repository<HsnCodes>,
        private hsnCodesAdapter: HsnCodesAdapter,
    ) { }
    /**
     * Create Or Update Hsn Code
     * @param hsnCodesDTO 
     * @param isUpdate 
     * @param request 
     */
    async createHsnCode(hsnCodesDTO: HsnCodesDTO, isUpdate: boolean, request: Request): Promise<HsnResponseModel> {
        try {
            let previousValue;
            // to check whether Hsn Code exists with the passed  Hsn Code  or not. if isUpdate is false, a check will be done whether a record with the passed Hsn Code is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Hsn Code  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const HsnCodeEntity = await this.getHsnCodeDetailsWithoutRelations(hsnCodesDTO);
                if (HsnCodeEntity) {
                    throw new HsnResponseModel(false,11104, 'Hsn Code already exists');
                }
            }
            if (isUpdate) {
                const certificatePrevious = await this.hsnCodesRepository.findOne({where:{hsnCodeId:hsnCodesDTO.hsnCodeId}})
                previousValue = certificatePrevious.variantCode;
                const HsnCodeEntity = await this.getHsnCodeDetailsWithoutRelations(hsnCodesDTO);
                if (HsnCodeEntity) {
                    if (HsnCodeEntity?.hsnCodeId != hsnCodesDTO.hsnCodeId) {
                        throw new HsnResponseModel(false,11104, 'Hsn Code already exists');
                    }
                }
            }

            const convertedHsnCodeEntity: HsnCodes = this.hsnCodesAdapter.convertDtoToEntity(hsnCodesDTO, isUpdate);
            const savedHsnCodeEntity: HsnCodes = await this.hsnCodesRepository.save(
                convertedHsnCodeEntity
            );
            const savedHsnCodeDto: HsnCodesDTO = this.hsnCodesAdapter.convertEntityToDto(savedHsnCodeEntity);
            if (savedHsnCodeDto) {
               const present = savedHsnCodeDto.variantCode
                // generating resposnse
                const response = new HsnResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Hsn Code Updated Successfully' : 'Hsn Code Created Successfully', savedHsnCodeDto);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Hsn Code Updated Successfully': 'Hsn Code Created Successfully'
            const userName = isUpdate? savedHsnCodeDto.updatedUser :savedHsnCodeDto.createdUser;
                const newLogDto = new LogsDto(1,name, 'HsnCodes', savedHsnCodeDto.hsnCodeId, true, displayValue,userName,previousValue,present)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new HsnResponseModel(false,11106, 'Hsn Code saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * check Hsn COde Exist
     * @param hsnCode 
     */
    async getHsnCodeDetailsWithoutRelations(hsnCode: HsnCodesDTO): Promise<HsnCodes> {
        // tslint:disable-next-line: typedef
        const HsnCodeResponse = await this.hsnCodesRepository.findOne({
            where: { hsnCode: Raw(alias => `hsn_code = '${hsnCode.hsnCode}'`), productId: hsnCode.productId, foodTypeId: hsnCode.foodTypeId, valueAdditionOneId: hsnCode.valueAdditionOneId, valueAdditionTwoId: hsnCode.valueAdditionTwoId, valueAdditionThreeId: hsnCode.valueAdditionThreeId, valueAdditionFourId: hsnCode.valueAdditionFourId, valueAdditionFiveId: hsnCode.valueAdditionFiveId, variantCode: Raw(alias => `variant_code = '${hsnCode.variantCode}'`) },
        });
        if (HsnCodeResponse) {
            return HsnCodeResponse;
        } else {
            return null;
        }
    }
    /**
     * get All Hsn COdes
     */
    async getAllHsnCodes(req?:UserRequestDto): Promise<AllHsnResponseModel> {
        // const page: number = 1;
        try {
            const hsnCodesDTO: HsnCodesDTO[] = [];
            //retrieves all companies
            const CodesEntities: HsnCodes[] = await this.hsnCodesRepository.createQueryBuilder("hsn_codes")
                .select(["products.name as productName,food_types.food_type as foodType,value_addition_one_types.name as valueAdd1Name,value_addition_two_types.name as valueAdd2Name,value_addition_three_types.name as valueAdd3Name,value_addition_four_types.name as valueAdd4Name,value_addition_five_types.name as valueAdd5Name, hsn_codes.hsn_code_id as hsnCodeId,hsn_codes.food_type_id as foodTypeId,hsn_codes.value_addition_one_id as valueAdditionOneId,hsn_codes.value_addition_two_id as valueAdditionTwoId,hsn_codes.value_addition_three_id as valueAdditionThreeId,hsn_codes.value_addition_four_id as valueAdditionFourId,hsn_codes.value_addition_five_id as valueAdditionFiveId,hsn_codes.variant_code as variantCode,hsn_codes.hsn_code as hsnCode,hsn_codes.is_active as isActive,hsn_codes.created_at as createdAt,hsn_codes.created_user as createdUser,hsn_codes.updated_at as updatedAt,hsn_codes.updated_user as updatedUser,hsn_codes.version_flag as versionFlag, hsn_codes.product_id as productId"])
                .leftJoin("products", "products", 'products.product_id = hsn_codes.product_id')
                .leftJoin("food_types", "food_types", "food_types.food_type_id = hsn_codes.food_type_id")
                .leftJoin("value_addition_one_types", "value_addition_one_types", "value_addition_one_types.value_addition_one_id = hsn_codes.value_addition_one_id")
                .leftJoin("value_addition_two_types", "value_addition_two_types", "value_addition_two_types.value_addition_two_id = hsn_codes.value_addition_two_id")
                .leftJoin("value_addition_three_types", "value_addition_three_types", "value_addition_three_types.value_addition_three_id = hsn_codes.value_addition_three_id")
                .leftJoin("value_addition_four_types", "value_addition_four_types", "value_addition_four_types.value_addition_four_id = hsn_codes.value_addition_four_id")
                .leftJoin("value_addition_five_types", "value_addition_five_types", "value_addition_five_types.value_addition_five_id = hsn_codes.value_addition_five_id")
                .getRawMany();
            //console.log(CodesEntities);
            if (CodesEntities) {
                // converts the data fetched from the database which of type companies array to type hsnCodeseDto array.
                CodesEntities.forEach(hsnCodeEntity => {
                    const convertedhsnCodesDto: HsnCodesDTO = this.hsnCodesAdapter.convertEntityToDto(
                        hsnCodeEntity
                    );
                    hsnCodesDTO.push(convertedhsnCodesDto);
                });
                const response = new AllHsnResponseModel(true, 11108, "Hsn Codes retrieved successfully", CodesEntities);
               if(req?.createdUser){
                const newLogDto = new LogsDto(1,'view', 'HsnCodes', 0, true, 'Hsn Codes retrieved successfully',req.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
               }
                
                return response;
            } else {
                throw new HsnResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getAllActiveHsnCodes(): Promise<AllHsnResponseModel> {
        // const page: number = 1;
        try {
            const hsnCodesDTO: HsnCodesDTO[] = [];
            //retrieves all companies
            const CodesEntities: HsnCodes[] = await this.hsnCodesRepository.find({
                order: { hsnCode: 'ASC' }, where: { isActive: true }
            });
            console.log(CodesEntities)
            if (CodesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                CodesEntities.forEach(hsnCodeEntity => {
                    const convertedhsnCodesDto: HsnCodesDTO = this.hsnCodesAdapter.convertEntityToDto(
                        hsnCodeEntity
                    );
                    hsnCodesDTO.push(convertedhsnCodesDto);
                });
                const response = new AllHsnResponseModel(true, 11108, "HsnCodes retrieved successfully", hsnCodesDTO);
                return response;
            } else {
                throw new HsnResponseModel(false,99998, 'Data not found'); hsnCodesDTO
            }
        } catch (err) {
            throw err;
        }
    }


    /**
     * Activate or De-Activate Hsn COde
     * @param hsnCodesReq 
     */
    async activateOrDeactivateHsnCode(hsnCodesReq: HsnCodesRequest): Promise<HsnResponseModel> {
        try {
            const hsnCodeExists = await this.getHsnCodeById(hsnCodesReq.hsnCodeId);
            if (hsnCodeExists) {
                if (hsnCodesReq.versionFlag !== hsnCodeExists.versionFlag) {
                    throw new HsnResponseModel(false,10113, 'Someone updated the current Hsn Code information.Refresh and try again');
                } else {

                    const hsnCodeStatus = await this.hsnCodesRepository.update(
                        { hsnCodeId: hsnCodesReq.hsnCodeId },
                        { isActive: hsnCodesReq.isActive, updatedUser: hsnCodesReq.updatedUser });

                    if (hsnCodeExists.isActive) {
                        if (hsnCodeStatus.affected) {
                            const hsnCodeResponse: HsnResponseModel = new HsnResponseModel(true, 10115, 'Hsn Code is de-activated successfully');
                            return hsnCodeResponse;
                        } else {
                            throw new HsnResponseModel(false,10111, 'Hsn Code is already deactivated');
                        }
                    } else {
                        if (hsnCodeStatus.affected) {
                            const hsnCodeResponse: HsnResponseModel = new HsnResponseModel(true, 10114, 'Hsn Code is activated successfully');
                            return hsnCodeResponse;
                        } else {
                            throw new HsnResponseModel(false,10112, 'Hsn Code is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new HsnResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    /**
     * get Hsn Code by Id
     * @param hsnCodeId 
     */
    async getHsnCodeById(hsnCodeId: number): Promise<HsnCodes> {
        const Response = await this.hsnCodesRepository.findOne({
            where: { hsnCodeId: hsnCodeId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getHsnByFoodType(req: HsnRequest): Promise<HsnResponseModel> {
        try {
            const getDetails = await this.hsnCodesRepository.findOne({ where: { foodTypeId: req.foodTypeId, valueAdditionOneId: req.valueAddOneId, valueAdditionTwoId: req.valueAddTwoId, valueAdditionThreeId: req.valueAddThreeId, valueAdditionFourId: req.valueAddFourId, valueAdditionFiveId: req.valueAddFiveId, productId: req.productId } });
            if (getDetails != undefined) {
                const data = new HsnDto(getDetails.hsnCodeId, getDetails.productId, getDetails.variantCode, getDetails.valueAdditionOneId, getDetails.valueAdditionTwoId, getDetails.valueAdditionThreeId, getDetails.hsnCode, getDetails.createdUser,getDetails.updatedUser, getDetails.isActive);
                return new HsnResponseModel(true, 1001, "Hsn Details retrived successfully. ", data);
            }
            else {
                return new HsnResponseModel(false, 1010, "No data found. ");
            }
        }
        catch (err) {
            throw err;
        }
    }

}
